export enum PersonalTitle {
  EMPTY = "",
  DR = "Dr.",
  MR = "Mr.",
  MRS = "Mrs.",
  MS = "Ms.",
}
